import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import 'bootstrap/dist/css/bootstrap.min.css';

const CadetesReport = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [fecha, setFecha] = useState(new Date().toISOString().slice(0, 10));
 const abreDatas = (c) => {
    window.open('/CadeteEdit?dni=' + c.cadeteDni, '_blank');
  };

  const fetchData = async (fechaSeleccionada) => {
    setLoading(true);
    try {
      const res = await axios.post(
        'https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/obtenerCadetesUltimos30DiasPorSede/',
        { fecha: fechaSeleccionada }
      );
      setData(res.data || {});
    } catch (err) {
      console.error('Error al obtener los datos:', err);
      setData({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(fecha);
  }, [fecha]);

  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();

    // Libro 1: todos los registros por sede
    Object.keys(data).forEach((sede) => {
      const sedeData = data[sede];
      const ws = XLSX.utils.json_to_sheet(sedeData);
      XLSX.utils.book_append_sheet(wb, ws, sede);
    });

    // Libro 2: resumen diario
    const resumenPorDia = {};
    Object.values(data).flat().forEach((item) => {
      const f = item.fecha;
      if (!resumenPorDia[f]) resumenPorDia[f] = 0;
      resumenPorDia[f]++;
    });

    const resumenArray = Object.entries(resumenPorDia).map(([fecha, cantidad]) => ({
      Fecha: fecha,
      Cantidad: cantidad,
    }));

    const resumenSheet = XLSX.utils.json_to_sheet(resumenArray);
    XLSX.utils.book_append_sheet(wb, resumenSheet, 'Resumen Diario');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), 'reporte_cadetes '+fecha+'.xlsx');
  };

  return (
    <div style={{ width: '100%' }}>
      

      <div className="mb-4 d-flex align-items-center flex-wrap gap-3" style={{justifyContent:"center"}}>
        <label className="form-label mb-0">Elegir fecha:</label>
        <input
          type="date"
          className="form-control"
          style={{ maxWidth: 200 }}
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
        />
        <button className="btn btn-success" onClick={exportToExcel}>
          Exportar a Excel
        </button>
      </div>

      {loading ? (
        <div className="text-center">Cargando datos...</div>
      ) : Object.keys(data).length === 0 ? (
        <div className="alert alert-warning">No hay datos para la fecha seleccionada.</div>
      ) : (
        Object.entries(data).map(([sede, registros]) => (
          <div key={sede} className="mb-5">
            <h4 className="text-primary">{sede}</h4>

            {Object.entries(
              registros.reduce((acc, item) => {
                acc[item.fecha] = acc[item.fecha] || [];
                acc[item.fecha].push(item);
                return acc;
              }, {})
            ).map(([fechaGrupo, registrosPorFecha]) => (
              <div key={fechaGrupo} className="mb-4">
                <h5>
                  {fechaGrupo} – Total: <strong>{registrosPorFecha.length}</strong>
                </h5>
                <div style={{ overflowX: 'auto' }}>
                  <table className="table table-bordered table-striped w-100">
                    <thead className="table-dark">
                      <tr>
                        <th>#</th>
                        <th>DNI</th>
                        <th>Apellido</th>
                        <th>Nombre</th>
                        <th>Tipo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {registrosPorFecha.map((r, idx) => (
                        <tr key={idx} onClick={()=>abreDatas(r)}>
                          <td>{idx + 1}</td>
                          <td>{r.cadeteDni}</td>
                          <td>{r.cadeteApellido}</td>
                          <td>{r.cadeteNombre}</td>
                          <td>{r.tipoRegistro}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        ))
      )}
    </div>
  );
};

export default CadetesReport;
